<template>
  <div>
    <el-table
      :border="true"
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column v-if="hasPermissionToAuditLogs" :label="fields.id.label"  :prop="fields.id.name" sortable="custom">
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.name.label"
        :prop="fields.name.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'name') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.logo.label"
        :prop="fields.logo.name"
        align="center"
      >
        <template slot-scope="scope">
          <app-list-item-image :value="presenter(scope.row, 'logo')"></app-list-item-image>
        </template>
      </el-table-column>

      <el-table-column :label="fields.teams.label" :prop="fields.teams.name">
        <template slot-scope="scope">
          <app-list-item-relation-to-many
            :label="fields.teams.label"
            :permission="fields.teams.readPermission"
            :url="fields.teams.viewUrl"
            :value="presenter(scope.row, 'teams')"
          ></app-list-item-relation-to-many>
        </template>
      </el-table-column>

      <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/club/${scope.row.id}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link>

            <router-link :to="`/club/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button type="text">
                <app-i18n code="common.edit"></app-i18n>
              </el-button>
            </router-link>

            <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              type="text"
              v-if="hasPermissionToDestroy"
            >
              <app-i18n code="common.destroy"></app-i18n>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { ClubModel } from '@modules/club/club-model';
import { mapGetters, mapActions } from 'vuex';
import { ClubPermissions } from '@modules/club/club-permissions';
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { i18n } from '@shared/i18n';

const { fields } = ClubModel;

export default {
  name: 'app-club-list-table',

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'club/list/rows',
      count: 'club/list/count',
      loading: 'club/list/loading',
      pagination: 'club/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'club/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new ClubPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new ClubPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'club/list/doChangeSort',
      doChangePaginationCurrentPage:
        'club/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'club/list/doChangePaginationPageSize',
      doMountTable: 'club/list/doMountTable',
      doDestroy: 'club/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return ClubModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
